import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output, SimpleChanges,
  ViewChild
} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {NgClass, NgIf} from "@angular/common";

@Component({
  selector: 'app-custom-checkbox',
  templateUrl: './custom-checkbox.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgClass,
    NgIf
  ],
  styleUrls: ['./custom-checkbox.component.scss']
})
export class CustomCheckboxComponent implements OnInit, OnChanges {

  @Output() changeInput = new EventEmitter();
  @Input() type: | string = 'checkbox';
  @Input() labelText: any;
  @Input() value: any | undefined;
  @Input() id: any;
  @Input() class: any;
  @Input() checked: any;
  @Input() inputClass: any;
  @Input() labelClass: any;
  @Input() control: FormControl = new FormControl()

  @Input() controlValue: any;
  @ViewChild('radio') fileInput:any;
  @HostListener('click', ['$event.target'])
  onClick() {
    // @ts-ignore
    this.fileInput.nativeElement.click()
  }

  constructor() { }

  ngOnInit(): void {
    this.id = this.id+'_1';
    if (this.checked){
      this.onChangeRadio(this.value ? this.value : '')
    }

  }
  onChange(){
    this.changeInput.emit()
  }

  onChangeRadio(value: any) {
    this.controlValue = value.value;
    this.changeInput.emit(value.value)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['controlValue']) this.checked = (changes['controlValue'].currentValue === this.value)
  }
}
